module.exports = __webpack_public_path__ + "static/media/bs5.60b7152c.webp";